import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5V4H14V5H10ZM8 5V3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V5H19H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V7H4C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5H5H8ZM15 7H9H7V20H17V7H15ZM9 9.5C9 9.22386 9.22386 9 9.5 9H10.5C10.7761 9 11 9.22386 11 9.5V16.5C11 16.7761 10.7761 17 10.5 17H9.5C9.22386 17 9 16.7761 9 16.5V9.5ZM13 9.5C13 9.22386 13.2239 9 13.5 9H14.5C14.7761 9 15 9.22386 15 9.5V16.5C15 16.7761 14.7761 17 14.5 17H13.5C13.2239 17 13 16.7761 13 16.5V9.5Z",
    fill: "currentColor"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'delete_stroked');
export default IconComponent;